import Model from './model';

export default Model.extend( { 
    defaults() {
        return {
            id: undefined,
            name: undefined,
            label: undefined,
            array_index: 0,
            children: [],
            possible_values: [],
            type: undefined,
        };
    },

    endpoint: 'configuration/properties?apiVersion=1.4',
} );


// WEBPACK FOOTER //
// ./src/js/model/config.property.js